import { HStack, Checkbox, Text } from '@chakra-ui/react';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import { FORM_FIELD_PATHS } from '../../constants';
import { toast } from 'react-toastify';

const billingToggles = [
    {
        key: 'leadInProrata',
        label: 'Lead In Pro Rata',
        formPath: FORM_FIELD_PATHS.LEAD_IN_PRORATA,
        sx: { paddingTop: '7px' },
    },
    {
        key: 'processBilling',
        label: 'Process Billing',
        formPath: FORM_FIELD_PATHS.PROCESS_BILLING,
    },
    {
        key: 'omitNumberBlocks',
        label: 'Omit Number Blocks',
        formPath: FORM_FIELD_PATHS.OMIT_NUMBER_BLOCKS,
    },
];

const BillingToggles = () => {
    const { formData, updateFormData } = usePartnerForm();

    return (
        <HStack
            spacing={4}
            width="100%"
            alignItems="center"
            justify="right"
            paddingRight="70px"
            py={2}>
            {billingToggles.map((toggle) => (
                <Checkbox
                    key={toggle.key}
                    isChecked={
                        formData.partnerBillingSettings?.[toggle.key] || false
                    }
                    onChange={(e) => {
                        updateFormData(
                            `${FORM_FIELD_PATHS.BILLING_SETTINGS}.${toggle.key}`,
                            e.target.checked,
                        );

                        if (
                            !formData?.omitNumberBlocks &&
                            toggle.key === 'omitNumberBlocks' &&
                            e.target.checked
                        ) {
                            toast.info(
                                'Stop generating invoices (only for this entity)',
                                {
                                    toastId:
                                        new Date().getTime().toString() +
                                        Math.random(),
                                },
                            );
                        }
                    }}
                    display="flex"
                    alignItems="center"
                    height="40px"
                    sx={{ verticalAlign: 'middle', ...toggle.sx }}>
                    <Text
                        fontSize="13px"
                        lineHeight="40px"
                        height="40px"
                        display="flex"
                        alignItems="center">
                        {toggle.label}
                    </Text>
                </Checkbox>
            ))}
        </HStack>
    );
};

export default BillingToggles;
